/**
 * Widget runtime entry — built to dist-runtime/runtime/v1.js, served from
 * https://d.uenicontentcdn.com/cooltools/ccg/runtime/v1.js.
 *
 * Loaded once per customer venue (browser dedupes by URL). Drains the global
 * `__ccg` queue and lazy-loads the per-widget runtime modules via `<script src>`
 * injection — NOT dynamic `import()`, because `<script>` tags don't trigger
 * CORS preflight while ES module imports do, and we want the runtime to work
 * on any CDN config.
 *
 * Query-string inheritance: if this runtime is loaded with a query string
 * (e.g. `runtime/v1.js?cb=12345` from the live-preview iframe), we propagate
 * the same query string to the per-widget URLs. This lets the editor's iframe
 * cache-bust both layers in one shot, while customer venues (loading the
 * canonical no-query URL) keep using Cloudflare cache normally.
 */

import { dispatch } from './dispatcher';

const CDN_BASE = 'https://d.uenicontentcdn.com/cooltools/ccg/widgets';

// Capture the query string from this script's own <script> tag while the IIFE
// is still executing synchronously — `document.currentScript` becomes null
// once execution yields.
const myScript = document.currentScript as HTMLScriptElement | null;
const querySuffix = myScript?.src?.includes('?')
  ? myScript.src.substring(myScript.src.indexOf('?'))
  : '';

void dispatch({
  widgetUrl: (id, version) => `${CDN_BASE}/${id}/v${version}.js${querySuffix}`,
});
